<template>
  <b-modal
    id="final-action"
    size="md"
    centered
    hide-footer
    hide-header
    class="p-0"
    no-close-on-backdrop
    @hidden="closeFinalAction"
  >
    <b-overlay :show="showSpinner" rounded="sm">
      <div
        class="modalheading d-flex align-items-center justify-content-between"
      >
        <span class="caution-txt">Final Selection</span>
      </div>
      <hr />
      <div class="xMarkCancel" @click="closeFinalAction">
        <img src="../../../assets/cross-round.svg" alt="" />
      </div>
      <div>
        <div class="final-select-modal-text-kanban">
          This candidate was already selected and then moved to on-hold.
        </div>
        <div class="final-select-modal-text-kanban">
          So now you can select or reject the candidate.
        </div>
      </div>
      <div class="d-flex mt-4">
        <b-form-radio
          name="final-hold"
          value="true"
          @change="() => changeFinalSelect('true')"
        >
          <div class="radio-margins final-select-options-kanban">
            Select Candidate
          </div>
        </b-form-radio>
        <b-form-radio
          class="ml-4"
          name="final-hold"
          value="false"
          @change="() => changeFinalSelect('false')"
        >
          <div class="radio-margins final-select-options-kanban">
            Reject Candidate
          </div>
        </b-form-radio>
      </div>
      <div class="d-flex align-items-center justify-content-end">
        <b-button class="addbtn" @click="actionOnFinalHold"> Confirm </b-button>
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
import { actionOnnFinalHold } from "../asynchronous";
export default {
  name: "FinalAction",
  props: {
    context: Object,
  },
  data() {
    return {
      showSpinner: false,
    };
  },
  methods: {
    changeFinalSelect(val) {
      this.context.finalSelectedCandidate.select = val;
    },
    closeFinalAction() {
      this.$bvModal.hide("final-action");
    },
    async actionOnFinalHold() {
      this.showSpinner = true;
      await actionOnnFinalHold(this.context);
      this.showSpinner = false;
    },
  },
};
</script>
